export enum AnimationType {
  Idle = "Idle",
  Walk = "Walk",
  Sleep = "Sleep",
  Hurt = "Hurt",
  Attack = "Attack",
  Charge = "Charge",
  Shoot = "Shoot",
  Strike = "Strike",
  Chop = "Chop",
  Scratch = "Scratch",
  Punch = "Punch",
  Slap = "Slap",
  Slice = "Slice",
  MultiScratch = "MultiScratch",
  MultiStrike = "MultiStrike",
  Uppercut = "Uppercut",
  Ricochet = "Ricochet",
  Bite = "Bite",
  Shake = "Shake",
  Jab = "Jab",
  Kick = "Kick",
  Lick = "Lick",
  Slam = "Slam",
  Stomp = "Stomp",
  Appeal = "Appeal",
  Dance = "Dance",
  Twirl = "Twirl",
  TailWhip = "TailWhip",
  Sing = "Sing",
  Sound = "Sound",
  Rumble = "Rumble",
  FlapAround = "FlapAround",
  Gas = "Gas",
  Shock = "Shock",
  Emit = "Emit",
  SpAttack = "SpAttack",
  Withdraw = "Withdraw",
  RearUp = "RearUp",
  Swell = "Swell",
  Swing = "Swing",
  Double = "Double",
  Rotate = "Rotate",
  Hop = "Hop",
  Hover = "Hover",
  QuickStrike = "QuickStrike",
  EventSleep = "EventSleep",
  Wake = "Wake",
  Eat = "Eat",
  Tumble = "Tumble",
  Pose = "Pose",
  Pull = "Pull",
  Pain = "Pain",
  Float = "Float",
  DeepBreath = "DeepBreath",
  Nod = "Nod",
  Sit = "Sit",
  LookUp = "LookUp",
  Sink = "Sink",
  Trip = "Trip",
  Laying = "Laying",
  LeapForth = "LeapForth",
  Head = "Head",
  Cringe = "Cringe",
  LostBalance = "LostBalance",
  TumbleBack = "TumbleBack",
  HitGround = "HitGround",
  Faint = "Faint",
  Fainted = "Fainted",
  StandingUp = "StandingUp",
  DigIn = "DigIn",
  DigOut = "DigOut",
  Wiggle = "Wiggle",
  Yawn = "Yawn",
  RaiseArms = "RaiseArms",
  CarefulWalk = "CarefulWalk",
  Injured = "Injured",
  Jump = "Jump",
  Roar = "Roar",
  Wave = "Wave",
  Cry = "Cry",
  Bow = "Bow",
  Special0 = "Special0",
  Special1 = "Special1",
  Special2 = "Special2",
  Special3 = "Special3",
  Special4 = "Special4",
  Special5 = "Special5",
  Special6 = "Special6",
  Special7 = "Special7",
  Special8 = "Special8",
  Special9 = "Special9",
  Special10 = "Special10",
  Special11 = "Special11",
  Special12 = "Special12",
  Special13 = "Special13",
  Special14 = "Special14",
  Special15 = "Special15",
  Special16 = "Special16",
  Special17 = "Special17",
  Special18 = "Special18",
  Special19 = "Special19",
  Special20 = "Special20",
  Special21 = "Special21",
  Special22 = "Special22",
  Special23 = "Special23",
  Special24 = "Special24",
  Special25 = "Special25",
  Special26 = "Special26",
  Special27 = "Special27",
  Special28 = "Special28",
  Special29 = "Special29",
  Special30 = "Special30",
  Special31 = "Special31"
}

export const AnimationComplete: { [key in AnimationType]: boolean } = {
  [AnimationType.Idle]: true,
  [AnimationType.Walk]: true,
  [AnimationType.Sleep]: false,
  [AnimationType.Hurt]: true,
  [AnimationType.Attack]: true,
  [AnimationType.Charge]: true,
  [AnimationType.Shoot]: true,
  [AnimationType.Strike]: true,
  [AnimationType.Chop]: true,
  [AnimationType.Scratch]: true,
  [AnimationType.Punch]: true,
  [AnimationType.Slap]: true,
  [AnimationType.Slice]: true,
  [AnimationType.MultiScratch]: true,
  [AnimationType.MultiStrike]: true,
  [AnimationType.Uppercut]: true,
  [AnimationType.Ricochet]: true,
  [AnimationType.Bite]: true,
  [AnimationType.Shake]: true,
  [AnimationType.Jab]: true,
  [AnimationType.Kick]: true,
  [AnimationType.Lick]: true,
  [AnimationType.Slam]: true,
  [AnimationType.Stomp]: true,
  [AnimationType.Appeal]: true,
  [AnimationType.Dance]: true,
  [AnimationType.Twirl]: true,
  [AnimationType.TailWhip]: false,
  [AnimationType.Sing]: false,
  [AnimationType.Sound]: false,
  [AnimationType.Rumble]: true,
  [AnimationType.FlapAround]: true,
  [AnimationType.Gas]: true,
  [AnimationType.Shock]: true,
  [AnimationType.Emit]: true,
  [AnimationType.SpAttack]: true,
  [AnimationType.Withdraw]: true,
  [AnimationType.RearUp]: true,
  [AnimationType.Swell]: true,
  [AnimationType.Swing]: true,
  [AnimationType.Double]: true,
  [AnimationType.Rotate]: true,
  [AnimationType.Hop]: true,
  [AnimationType.Hover]: true,
  [AnimationType.QuickStrike]: true,
  [AnimationType.EventSleep]: false,
  [AnimationType.Wake]: false,
  [AnimationType.Eat]: false,
  [AnimationType.Tumble]: false,
  [AnimationType.Pose]: false,
  [AnimationType.Pull]: false,
  [AnimationType.Pain]: false,
  [AnimationType.Float]: false,
  [AnimationType.DeepBreath]: false,
  [AnimationType.Nod]: true,
  [AnimationType.Sit]: false,
  [AnimationType.LookUp]: false,
  [AnimationType.Sink]: false,
  [AnimationType.Trip]: false,
  [AnimationType.Laying]: false,
  [AnimationType.LeapForth]: false,
  [AnimationType.Head]: false,
  [AnimationType.Cringe]: false,
  [AnimationType.LostBalance]: false,
  [AnimationType.TumbleBack]: false,
  [AnimationType.HitGround]: false,
  [AnimationType.Faint]: false,
  [AnimationType.Fainted]: false,
  [AnimationType.StandingUp]: false,
  [AnimationType.DigIn]: false,
  [AnimationType.DigOut]: false,
  [AnimationType.Wiggle]: false,
  [AnimationType.Yawn]: false,
  [AnimationType.RaiseArms]: false,
  [AnimationType.CarefulWalk]: false,
  [AnimationType.Injured]: false,
  [AnimationType.Jump]: false,
  [AnimationType.Roar]: false,
  [AnimationType.Wave]: false,
  [AnimationType.Cry]: false,
  [AnimationType.Bow]: false,
  [AnimationType.Special0]: false,
  [AnimationType.Special1]: false,
  [AnimationType.Special2]: false,
  [AnimationType.Special3]: false,
  [AnimationType.Special4]: false,
  [AnimationType.Special5]: false,
  [AnimationType.Special6]: false,
  [AnimationType.Special7]: false,
  [AnimationType.Special8]: false,
  [AnimationType.Special9]: false,
  [AnimationType.Special10]: false,
  [AnimationType.Special11]: false,
  [AnimationType.Special12]: false,
  [AnimationType.Special13]: false,
  [AnimationType.Special14]: false,
  [AnimationType.Special15]: false,
  [AnimationType.Special16]: false,
  [AnimationType.Special17]: false,
  [AnimationType.Special18]: false,
  [AnimationType.Special19]: false,
  [AnimationType.Special20]: false,
  [AnimationType.Special21]: false,
  [AnimationType.Special22]: false,
  [AnimationType.Special23]: false,
  [AnimationType.Special24]: false,
  [AnimationType.Special25]: false,
  [AnimationType.Special26]: false,
  [AnimationType.Special27]: false,
  [AnimationType.Special28]: false,
  [AnimationType.Special29]: false,
  [AnimationType.Special30]: false,
  [AnimationType.Special31]: false
}
